import ProductTileButton from './product-tile-button';

export default ProductTileButton;
